/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSummaryColorCategory_user = {
    readonly id: string;
    readonly webAppFlagsErrorable: ({
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "Flags";
        readonly flags: ReadonlyArray<string | null> | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $refType": "EventSummaryColorCategory_user";
};
export type EventSummaryColorCategory_user$data = EventSummaryColorCategory_user;
export type EventSummaryColorCategory_user$key = {
    readonly " $data"?: EventSummaryColorCategory_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSummaryColorCategory_user">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSummaryColorCategory_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "webAppFlagsErrorable",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "flags",
                            "storageKey": null
                        }
                    ],
                    "type": "Flags",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any;
(node as any).hash = 'b0f95276ff5d7946034b9b3b1bd9a950';
export default node;
